import { Card } from '@kalos/ui';
import { CheckCircle } from 'lucide-react';
import type { FC } from 'react';

interface HelcimCheckoutCompleteProps {
  logoUrl?: string;
  amount: number;
  transactionId?: string;
}

export const HelcimCheckoutComplete: FC<HelcimCheckoutCompleteProps> = ({
  logoUrl,
  amount,
  transactionId,
}) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <Card className="max-w-md p-8 text-center">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-green-100">
          <CheckCircle className="h-10 w-10 text-green-600" />
        </div>

        <h1 className="mb-3 text-2xl font-bold text-gray-900">Payment Successful!</h1>

        <p className="mb-6 text-gray-600">
          Thank you for your payment. Your transaction has been completed successfully.
        </p>

        <div className="mb-6 rounded-lg bg-gray-50 p-4">
          <div className="text-sm text-gray-600">Amount Paid</div>
          <div className="text-2xl font-bold text-green-600">${amount.toFixed(2)}</div>
          {transactionId && (
            <div className="mt-2 text-xs text-gray-500">Transaction ID: {transactionId}</div>
          )}
        </div>

        <div className="space-y-3 text-sm text-gray-600">
          <p>A confirmation email will be sent to your registered email address.</p>
          <p>
            If you have any questions, please contact Kalos Services at{' '}
            <a href="tel:3522437088" className="text-blue-600 hover:underline">
              (352) 243-7088
            </a>{' '}
            or{' '}
            <a href="mailto:office@kalosflorida.com" className="text-blue-600 hover:underline">
              office@kalosflorida.com
            </a>
          </p>
        </div>

        <div className="mt-8 border-t pt-4">
          {logoUrl && (
            <img src={logoUrl} alt="Kalos Services" className="mx-auto h-8 w-auto opacity-50" />
          )}
        </div>
      </Card>
    </div>
  );
};
